module.exports = __webpack_public_path__ + "static/media/s_8.c45616c3.mp3";